import React, { useState, useEffect, useRef } from 'react'

const ProgressBar = ({ id, label, percent, color = 'from-accent-dark to-accent' }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [count, setCount] = useState(0);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!isVisible) return;
    let start = 0;
    const end = percent;
    const duration = 1500;
    const increment = end / (duration / 16);
    const timer = setInterval(() => {
      start += increment;
      if (start >= end) {
        setCount(end);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 16);
    return () => clearInterval(timer);
  }, [isVisible, percent]);

  return (
    <div
      ref={ref}
      className="flex items-center my-4 group"
      data-aos="fade-up"
      data-aos-duration="600"
      data-aos-delay={id * 80}
    >
      <span className="mr-3 lg:mr-4 text-accent font-semibold min-w-[90px] lg:min-w-[110px] text-xs lg:text-sm tracking-wide">
        {label}
      </span>
      <div className="flex-1 h-3 lg:h-3.5 bg-primary-card rounded-full overflow-hidden border border-primary-border relative">
        {/* Background shimmer */}
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent animate-shimmer" />

        {/* Progress fill */}
        <div
          className={`h-full bg-gradient-to-r ${color} rounded-full flex items-center justify-end transition-all duration-300 relative overflow-hidden skill-glow`}
          style={{
            width: isVisible ? `${percent}%` : '0%',
            transition: 'width 1.5s cubic-bezier(0.4, 0, 0.2, 1)',
          }}
        >
          {/* Inner glow */}
          <div className="absolute inset-0 bg-gradient-to-t from-transparent to-white/10" />

          <span className="text-[10px] font-bold text-primary-bg mr-2 relative z-10 counter-number">
            {count}%
          </span>
        </div>
      </div>
    </div>
  )
}

export default ProgressBar
